import { type Project } from '@/entities/project';
import request from '@/shared/api/request';

export const getProject = (uuid: string): Promise<{ project: Project }> =>
  request({
    url: `/projects/${uuid}/`,
  });
